import type { FC } from 'react';

export const QuestionMarkOutlined: FC = () => {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M10.8115 8.7718C10.5852 9.08613 10.5 9.49336 10.5 9.75H8.5C8.5 9.17331 8.66478 8.33053 9.18847 7.6032C9.74886 6.82487 10.6741 6.25 12 6.25C12.9772 6.25 13.8693 6.58011 14.5196 7.23039C15.1687 7.87949 15.4988 8.76951 15.5 9.74467C15.5107 10.8964 14.909 11.6526 14.3427 12.1358C14.0768 12.3627 13.7985 12.547 13.5942 12.6823L13.5781 12.693C13.3345 12.8544 13.245 12.9192 13.2071 12.9571C13.1011 13.0631 13.0681 13.1335 13.0431 13.2586C13.0043 13.4523 13 13.7139 13 14.25H11L10.9998 14.1141C10.9976 13.2379 10.9954 12.3404 11.7929 11.5429C11.9916 11.3441 12.2567 11.169 12.438 11.0492L12.4734 11.0258C12.6922 10.8808 12.8781 10.7563 13.0447 10.6142C13.3566 10.3481 13.5039 10.1061 13.5001 9.76099L13.4999 9.75C13.4999 9.22725 13.3301 8.86933 13.1054 8.64461C12.8807 8.41989 12.5228 8.25 12 8.25C11.3259 8.25 11.0011 8.50847 10.8115 8.7718Z"
				fill="#1C308B"
			/>
			<path
				d="M13 16.75C13 17.3023 12.5523 17.75 12 17.75C11.4477 17.75 11 17.3023 11 16.75C11 16.1977 11.4477 15.75 12 15.75C12.5523 15.75 13 16.1977 13 16.75Z"
				fill="#1C308B"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12Z"
				fill="#1C308B"
			/>
		</svg>
	);
};
